const fullscreenReducerDefaultState = {
    fullscreen: false
};

export default (state = fullscreenReducerDefaultState, action) => {
    switch (action.type) {
        case 'FULL_SCREEN':
            return {
                ...state,
                fullscreen: true
            };
        case 'REGULAR_SCREEN':
            return {
                ...state,
                fullscreen: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/fullscreen.js